
export class GetPricingSurveyCommand {
  constructor(
    public surveyId: string,
    public valueAssessmentId: string
  ) { }
}
